import Domain from "./Domain";
import Select from "react-select";
import { useIntl } from "react-intl";
import React, { useState } from "react";
import { Form } from "react-bootstrap";

function DomainList(props) {
  var filterData = {
    "ns": "none",
    "ds": "none",
    "mx": "none",
    "spf": "none",
    "dkim": "none",
    "dmarc": "none",
    "caa": "none",
    "mta-sts": "none",
    "bimi": "none",
  };
  const intl = useIntl();
  const [selectValue, setValue] = useState(filterData);
  const [nameFilter, setNameFilter] = useState(".*");

  const handleChange = (e, name) => {
    let changed = {};
    for (let key in selectValue) {
      changed[key] = selectValue[key];
    }
    changed[name] = e.value;
    setValue(changed);
  };

  const handleNameFilterChange = (e) => {
    e.preventDefault();
    setNameFilter(e.target.value);
  };

  var domains = props.data.results.map(function (data) {
    if (data["domain"].match(nameFilter) == null) {
      return "";
    }
    for (let key in selectValue) {
      if (selectValue[key] === "none") {
        continue;
      }
      if (!(key in data)) {
        return "";
      }
      if (!("status" in data[key])) {
        return "";
      }
      if (selectValue[key] !== data[key]["status"]) {
        return "";
      }
    }
    return <Domain key={data.domain} data={data} />;
  });

  const mail_status = [
    { value: "none", label: "*" },
    {
      value: "supported",
      label: intl.formatMessage({ id: "domain.supported" }),
    },
    {
      value: "unsupported",
      label: intl.formatMessage({ id: "domain.unsupported" }),
    },
    { value: "error", label: intl.formatMessage({ id: "domain.error" }) },
    { value: "bad", label: intl.formatMessage({ id: "domain.bad" }) },
  ];

  const ds_status = [
    { value: "none", label: "*" },
    {
      value: "supported",
      label: intl.formatMessage({ id: "domain.supported" }),
    },
    {
      value: "unsupported",
      label: intl.formatMessage({ id: "domain.unsupported" }),
    },
    { value: "error", label: intl.formatMessage({ id: "domain.error" }) },
  ];

  const ns_status = [
    { value: "none", label: "*" },
    {
      value: "supported",
      label: intl.formatMessage({ id: "domain.supported" }),
    },
    { value: "child", label: intl.formatMessage({ id: "domain.child" }) },
    {
      value: "unsupported",
      label: intl.formatMessage({ id: "domain.unsupported" }),
    },
    { value: "error", label: intl.formatMessage({ id: "domain.error" }) },
    { value: "not_found", label: intl.formatMessage({ id: "domain.child" }) },
    { value: "bad", label: intl.formatMessage({ id: "domain.bad" }) },
    {
      value: "tcp_not_supported",
      label: intl.formatMessage({ id: "ns.tcp_not_supported" }),
    },
  ];

  const mx_status = [
    { value: "none", label: "*" },
    {
      value: "supported",
      label: intl.formatMessage({ id: "domain.supported" }),
    },
    { value: "null_mx", label: intl.formatMessage({ id: "domain.null_mx" }) },
    {
      value: "unsupported",
      label: intl.formatMessage({ id: "domain.unsupported" }),
    },
    { value: "error", label: intl.formatMessage({ id: "domain.error" }) },
    { value: "bad", label: intl.formatMessage({ id: "domain.bad" }) },
  ];

  const caa_status = [
    { value: "none", label: "*" },
    {
      value: "supported",
      label: intl.formatMessage({ id: "domain.supported" }),
    },
    {
      value: "unsupported",
      label: intl.formatMessage({ id: "domain.unsupported" }),
    },
    { value: "error", label: intl.formatMessage({ id: "domain.error" }) },
  ];

  const mta_sts_status = [
    { value: "none", label: "*" },
    {
      value: "supported",
      label: intl.formatMessage({ id: "domain.supported" }),
    },
    {
      value: "unsupported",
      label: intl.formatMessage({ id: "domain.unsupported" }),
    },
    { value: "error", label: intl.formatMessage({ id: "domain.error" }) },
  ];

  //https://react-hook-form.com/jp/get-started#IntegratingwithUIlibraries
  return (
    <table className="table">
      <thead>
        <tr>
          <th scope="col">org</th>
          <th scope="col">name</th>
          <th scope="col">NS</th>
          <th scope="col">DNSSEC</th>
          <th scope="col">MX</th>
          <th scope="col">SPF</th>
          <th scope="col">DKIM</th>
          <th scope="col">DMARC</th>
          <th scope="col">BIMI</th>
          <th scope="col">CAA</th>
          <th scope="col">MTA-STS</th>
        </tr>
        <tr>
          <th></th>
          <th>
            <Form.Control
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
              value={nameFilter}
              onChange={handleNameFilterChange}
            />
          </th>
          <th>
            <Select
              name="ns"
              options={ns_status}
              onChange={(e) => handleChange(e, "ns")}
            />
          </th>
          <th>
            <Select
              name="ds"
              options={ds_status}
              onChange={(e) => handleChange(e, "ds")}
            />
          </th>
          <th>
            <Select
              name="mx"
              options={mx_status}
              onChange={(e) => handleChange(e, "mx")}
            />
          </th>
          <th>
            <Select
              name="spf"
              options={mail_status}
              onChange={(e) => handleChange(e, "spf")}
            />
          </th>
          <th>
            <Select
              name="dkim"
              options={mail_status}
              onChange={(e) => handleChange(e, "dkim")}
            />
          </th>
          <th>
            <Select
              name="dmarc"
              options={mail_status}
              onChange={(e) => handleChange(e, "dmarc")}
            />
          </th>
          <th>
            <Select
              name="bimi"
              options={mail_status}
              onChange={(e) => handleChange(e, "bimi")}
            />
          </th>
          <th>
            <Select
              name="caa"
              options={caa_status}
              onChange={(e) => handleChange(e, "caa")}
            />
          </th>
          <th>
            <Select
              name="mta-sts"
              options={mta_sts_status}
              onChange={(e) => handleChange(e, "mta-sts")}
            />
          </th>
        </tr>
      </thead>
      <tbody>{domains}</tbody>
    </table>
  );
}

export default DomainList;
